import { css, ElementStyles } from '@microsoft/fast-element';
import {
  AnchoredRegion,
  ElementDefinitionContext,
  FoundationElementDefinition,
  forcedColorsStylesheetBehavior,
} from '@microsoft/fast-foundation';
import { mixinRobotoRegular } from '../../../styles';

export const tooltipStyles = `
    line-height: normal;
    justify-content: center;
    height: fit-content;
    font-size: 14px;
    padding: 8px;
    border-radius: 4px;
    border: 1px solid #2e3339;
    display: inline-block;
    max-width: 250px;
    background: #000000;
    white-space: normal;
    color: var(--white);
    align-items: center;
    z-index: 100000;
`;

export const customTooltipStyles = (
  context: ElementDefinitionContext,
  definition: FoundationElementDefinition,
): ElementStyles => {
  const anchoredRegionTag = context.tagFor(AnchoredRegion);
  return css`
    :host {
      contain: size;
      overflow: visible;
      height: 0;
      width: 0;
    }

    .tooltip {
      ${mixinRobotoRegular}
      ${tooltipStyles}
    }

    ${anchoredRegionTag} {
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: visible;
      flex-direction: row;
    }
  `.withBehaviors(
    forcedColorsStylesheetBehavior(css`
      :host([disabled]) {
        opacity: 1;
      }
    `),
  );
};
